<!-- 表单的筛选 -->
<template>
    <div>
        <el-tag :type="tagclass">{{tagtext}}</el-tag>
    </div>    
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "StatusTag",
  
  mixins: [BaseVue],
  
  props: {
    status: {
      type: Number,
      default: 0
    }
  },
  
  data() {
    return {
      tagclass: "info",
      tagtext: ""
    };
  },
  
  methods: {
    init() {
      if (this.status == 0) {
        this.tagclass = "success";
        this.tagtext = "启用中";
      } else if (this.status == 1) {
        this.tagclass = "warning";
        this.tagtext = "未启用";
      } else if (this.status == 2) {
        this.tagclass = "info";
        this.tagtext = "已删除";
      } else if (this.status == 3) {
        this.tagclass = "info";
        this.tagtext = "审核中";
      } else {
        this.tagclass = "info";
        this.tagtext = "未定义";
      }
    }
  },
  
  watch: {
    status: {
      handler() {
        this.init();
      },
      immediate: true
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
